@switch (columnName) {
  @case ('tasks') {
    {{ element.tasks?.length || 0 }}
  }
  @case ('createdAt') {
    {{ element[columnName] | date: dateFormat }}
  }
  @case ('marineManagerIssueTasks') {
    <div class="marine-manager-issue-description">
      {{ element.description }}
    </div>
    @if (element.tasks?.length) {
      <table class="tasks-table">
        <thead>
          <tr>
            <th>{{ 'description' | translate }}</th>
            <th>{{ 'status' | translate }}</th>
            <th>{{ 'dueDate' | translate }}</th>
            <th>{{ 'assignee' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (task of element.tasks; track task.id) {
            <tr>
              <td>{{ task.description }}</td>
              <td>{{ task.status | titlecase }}</td>
              <td>{{ task.dueDate | date }}</td>
              <td>{{ task.assigneeFirstName }} {{ task.assigneeLastName }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  }
  @case ('status') {
    {{ element[columnName] | titlecase }}
  }
  @default {
    {{ element[columnName] }}
  }
}
